import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '@vds-core/theme';
import { calculateRem } from '@uie/javascript-style-helpers';
import { withVDSManager } from '@vds-core/utilities';
import { Title, TitleConfig, Micro, MicroConfig, TypographyConfig } from '@vds-core/typography';
var propTypes = {
  /**
   * Represents the text or value of price in PricingLockup.
   */
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /**
   * Represents the text that is rendered next to price in the Pricing Lockup.
   */
  labelTop: PropTypes.string,

  /**
   * Represents the text that is rendered next to price in the Pricing Lockup.
   */
  labelBottom: PropTypes.string,

  /**
   * Represents the color scheme of the Pricing Lockup.
   */
  inverted: PropTypes.bool,

  /**
   * If provided, used as string that labels the element for accessibility.
   */
  ariaLabel: PropTypes.string,

  /**
   * If provided, adds a tab stop for accessibility.
   */
  tabIndex: PropTypes.number,

  /**
   * @ignore
   */
  padding: PropTypes.bool,
  //this will turn padding between labels on or off

  /**
   * @ignore
   */
  titleConfig: PropTypes.object,

  /**
   * @ignore
   */
  microConfig: PropTypes.object,

  /**
   * @ignore
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   */
  lockupConfig: PropTypes.object,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string
};
var defaultProps = {
  inverted: false,
  padding: true,
  titleConfig: TitleConfig,
  microConfig: MicroConfig,
  typescale: TypographyConfig.getTypescale(),
  lockupConfig: undefined
};

function _alignLabels(labelTop, labelBottom) {
  if (labelBottom && !labelTop) {
    return 'flex-end';
  } else if (labelTop && !labelBottom) {
    return 'flex-start';
  } else {
    return 'center';
  }
}

var PricingWrapper = /*#__PURE__*/styled.p.withConfig({
  displayName: "PricingWrapper",
  componentId: "sc-157xffu-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: ", ";\n  background-color: ", ";\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none;\n  }\n  * {\n    &:active,\n    &:focus,\n    &:hover {\n      outline: none;\n    }\n  }\n"])), function (_ref) {
  var labelTop = _ref.labelTop,
      labelBottom = _ref.labelBottom;
  return _alignLabels(labelTop, labelBottom);
}, function (_ref2) {
  var inverted = _ref2.inverted;
  return inverted ? colors.black : colors.white;
});
var StyledLabelWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledLabelWrapper",
  componentId: "sc-157xffu-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  padding-left: 4px;\n  padding-bottom: ", "px;\n"])), function (_ref3) {
  var top = _ref3.top,
      padding = _ref3.padding;
  return top && padding ? 2 : 0;
});
var LabelWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "LabelWrapper",
  componentId: "sc-157xffu-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: ", ";\n"])), function (_ref4) {
  var padding = _ref4.padding;
  return padding ? calculateRem(2, 0, 2, 0) : 0;
});

var PricingLockup = function PricingLockup(_ref5) {
  var price = _ref5.price,
      labelTop = _ref5.labelTop,
      labelBottom = _ref5.labelBottom,
      inverted = _ref5.inverted,
      titleConfig = _ref5.titleConfig,
      microConfig = _ref5.microConfig,
      padding = _ref5.padding,
      typescale = _ref5.typescale,
      lockupConfig = _ref5.lockupConfig,
      ariaLabel = _ref5.ariaLabel,
      tabIndex = _ref5.tabIndex,
      className = _ref5.className,
      id = _ref5.id;
  return /*#__PURE__*/React.createElement(PricingWrapper, {
    id: id,
    className: className,
    inverted: inverted,
    labelBottom: labelBottom,
    labelTop: labelTop
  }, /*#__PURE__*/React.createElement(Title, {
    typescale: typescale,
    config: titleConfig,
    size: "large",
    color: inverted ? colors.white : colors.black,
    primitive: "span"
  }, "$", price), /*#__PURE__*/React.createElement(LabelWrapper, {
    tabIndex: -1,
    padding: padding
  }, /*#__PURE__*/React.createElement(StyledLabelWrapper, {
    tabIndex: -1,
    top: true,
    padding: padding
  }, /*#__PURE__*/React.createElement(Micro, {
    primitive: "span",
    typescale: typescale,
    config: lockupConfig ? lockupConfig : microConfig,
    color: inverted ? colors.white : colors.black
  }, labelTop)), /*#__PURE__*/React.createElement(StyledLabelWrapper, {
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(Micro, {
    primitive: "span",
    typescale: typescale,
    config: microConfig,
    style: {
      whiteSpace: 'nowrap'
    },
    color: inverted ? colors.white : colors.black
  }, labelBottom))));
};

PricingLockup.propTypes = propTypes;
PricingLockup.defaultProps = defaultProps;
export default withVDSManager(PricingLockup);